import { findIndex } from '.';
/**
 * Converts bytes number to string representation (e.g. `15.25 GB`).
 *
 * @example
 * ```
 * formatBytes(1648 * 9884)
 * // '15.53 MB'
 * ```
 */
export function formatBytes(bytes, decimals) {
    if (decimals === void 0) { decimals = 2; }
    if (bytes <= 0)
        return '0 Bytes';
    var k = 1024;
    var dm = decimals < 0 ? 0 : decimals;
    var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    var i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}
/**
 * Parses size string to bytes.
 *
 * @example
 * ```
 * parseSize('15.53 MB')
 * // 16288832
 * ```
 * @returns parsed bytes or `-1` on fail
 */
export function parseSize(value) {
    var _a;
    var _b = (_a = value.match(/^(\d+(?:[.]\d+|))\s*([a-z]+)$/i)) !== null && _a !== void 0 ? _a : [], _ = _b[0], rawSize = _b[1], rawUnit = _b[2];
    var k = 1024;
    var units = [
        ['bytes', 'byte', 'b'],
        ['kb'],
        ['mb'],
        ['gb'],
        ['tb'],
        ['pb'],
        ['eb'],
        ['zb'],
        ['yb'],
    ];
    if (rawSize && rawUnit) {
        var size = parseFloat(rawSize);
        var unit_1 = rawUnit.toLowerCase();
        var index = findIndex(units, function (v) { return v.indexOf(unit_1) !== -1; });
        var bytes = size;
        while (index > 0) {
            bytes = bytes * k;
            index--;
        }
        return bytes;
    }
    return 0;
}
/**
 * Split the pathname path into a pair (root, ext) such that root + ext == path,
 * and ext is empty or begins with a period and contains at most one period.
 * Leading periods on the basename are ignored.
 *
 * @example
 * ```
 * getFileParts('file.txt')
 * // ['file', '.txt']
 *
 * getFileParts('.cshrc')
 * // ['.cshrc', '']
 * ```
 */
export function getFileParts(pathname) {
    var _a;
    var lastDirectory = (_a = pathname.split('/').pop()) !== null && _a !== void 0 ? _a : '';
    var parts = lastDirectory.split('.');
    var hasLeadingDot = lastDirectory[0] === '.';
    var minDotCount = hasLeadingDot ? 2 : 1;
    var extension = parts.length > minDotCount ? parts.pop() : undefined;
    return [
        extension ? pathname.slice(0, -1 * (extension.length + 1)) : pathname,
        extension ? "." + extension : '',
    ];
}
